var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recommend-by"},[_c('span',{ref:"recommend-by-box",staticClass:"recommend-by-box"},[_c('img',{staticClass:"avatarPic",attrs:{"src":_vm.avatarPic,"alt":""}}),_c('span',{ref:"userName",class:[
        'userName',
        { 'scrollShow': _vm.scrollShow }
      ]},[_vm._v(_vm._s(_vm.userName)+" "),(_vm.scrollShow)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.space)}}):_vm._e()]),(_vm.scrollShow)?_c('span',{class:[
        'userName',
        { 'scrollShow': _vm.scrollShow }
      ]},[_vm._v(_vm._s(_vm.userName)+" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.space)}})]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }